module.exports = __webpack_public_path__ + "img/intro_uk.ba432f9a.svg";